import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

interface Tab {
    readonly id: string
    readonly label: string
}

export const useTabs = (tabs: readonly Tab[]) => {
    type TabNames = (typeof tabs)[number]['id']

    const [searchParams, setSearchParams] = useSearchParams()
    const activeTab = useMemo(() => {
        const defaultTab = tabs[0].id as TabNames
        const paramTab = searchParams.get('viewTab') as TabNames
        return paramTab || defaultTab
    }, [searchParams, tabs])

    const setActiveTab = (tabId: TabNames) => {
        setSearchParams(prev => {
            prev.set('viewTab', tabId)
            return prev
        })
    }

    return { activeTab, setActiveTab }
}
